module.exports = "/static/img/placeholder5.jpg?02277fbff55fb2af8cc0d28c97f18a7a";